import styles from './Contact.module.css';
import { useEffect, useState } from 'react';

import ContactSVG from '../../components/SVG/Contact/Contact';
import { animations, removeAnimation } from '../../scripts/animations';

import './contact-animations.css'

export default function Contact({ visited }) {
    const [send, setSend] = useState(false)
        
    const displayMessage = (form,element) => {
        form.classList.remove('appeard');
        form.style.opacity = 0;
        element.style.display = "block"

        for (let element of form) {
            element.disabled = true;
        }
        setSend(true);

        setTimeout(() => {
            element.style.opacity = 1;
        }, 100);
    }
    
    useEffect(() => {
        if (!visited) {
            animations(0, '.group-contact');
        } else {
            removeAnimation('.group-contact')
        }
    }, [])

    const formSuccess = form => {
        let successMessage = document.querySelector('#form-success')

        displayMessage(form, successMessage)
    }

    const formError = form => {
        let errorMessage = document.querySelector("#form-error");

        displayMessage(form, errorMessage)
    }

    const submitHandler = e => {
        const form = document.querySelector("#contact-form");

        e.preventDefault();

        let datas = new FormData(form);

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(datas).toString(),
            })
            .then(() =>  formSuccess(form))
            .catch((error) => formError(form));
    }

    return (
        <main className='main-vertical'>
            <section className='text-section section-vertical px-4'>
                <h1 className='title group-contact toScale'>Contact</h1> 
                <p className={`${styles.titleParagraph} group-contact hide`}>Je suis ouverte à toute offre d'emploi ou projet !</p>
                <div className={styles.formContainer}>
                    <form data-netlify='true' 
                        onSubmit={submitHandler} 
                        className={`${styles.form} group-contact hide`} 
                        method="post" 
                        id="contact-form"
                        autoComplete='true'>
                        <input type="hidden" name="form-name" value="contact" />
                        <label >
                            Nom <input maxLength="100" minLength="1" type="text" name="name" id="name"  required placeholder='Nom' title="Veuillez entrer un nom valide."/>
                        </label>
                        <label >
                            Email <input maxLength="320" minLength="3" title="Veuillez entrer une adresse mail valide." type="email" name="email" id="email" required placeholder='Email'/>
                        </label>
                        <label>
                            Message
                            <textarea maxLength="2000" minLength="10" title="Veuillez entrer un message valide." name="message" id="messsage" required placeholder='Message...'></textarea>
                        </label>
                        <button type="submit" className={styles.sendButton} id="submit">Envoyer</button>
                    </form>
                    <div className={styles.formMessage} id="form-success">
                        <p>Message envoyé avec succès ! <i className="fa-solid fa-face-laugh-beam"></i></p>
                    </div>
                    <div className={styles.formMessage} id="form-error">
                        <p>Une erreur est survenue. Veuillez m'excuser pour la gêne occasionnée. <i className="fa-solid fa-face-frown"></i></p>
                    </div>
                </div>
                <div className='group-contact hide'>
                    <p className={styles.contactOther}>Vous pouvez aussi me contacter sur mon <a rel="noreferrer" href="https://www.linkedin.com/in/erika-andre-do-brito/" target="_blank" className={styles.link}>linkedin</a></p>
                    <p className={styles.contactOther}>Ou directement via <a href="mailto:adb.e@hotmail.com" className={styles.link}>email</a></p>
                </div>
            </section>
            <div className={`SVG ${styles.contactSVG}`} >
                <ContactSVG send={send} visited={visited}></ContactSVG>
            </div>
        </main>
    )
}
